import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.test';

@Injectable()
export class UsersConfiguracionesService {
  private resourceUrl = environment.API_URL + '/user-configuraciones';

  constructor(private http: HttpClient) {}

  updateMensajeInicial(): Observable<any> {
    return this.http.put(
      `${this.resourceUrl}/actualizar-mensaje-inicial/current`,
      {},
      { observe: 'response' },
    );
  }
}
